import type { PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody } from '@fukuri-admins/apis/client/gen/model';
import type { EditClientAdminUserFormFieldValues } from '../schema';

type Args = {
  formValues: EditClientAdminUserFormFieldValues;
};

/**
 * フォームの値から PUT リクエストボディを生成する
 */
export const generatePutRequestBody = ({
  formValues,
}: Args): PutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdBody => ({
  client_admin_user: {
    full_name: formValues.fullName,
    email: formValues.email,
    password: formValues.password || null,
    password_confirmation: formValues.passwordConfirmation || null,
  },
});
